import { default as currencies } from "@piotrgorecki/i18n-currency-name/src/langs/en.json";

export default currencies;
